import { debounce } from 'lodash-es';
import { useEffect } from 'react';

/**
 * TODO: 其他系统使用
 * 控制keyword文字缩放比例
 * @param param0
 */
export default function useKeywordWordCloud({
  data,
  parentClassName,
}: {
  data: any;
  parentClassName: string;
}) {
  function setRectScale() {
    setTimeout(() => {
      const svgElement = document
        .querySelector(parentClassName)
        ?.querySelector('svg');
      const rectElement = svgElement?.querySelector('rect');
      const gElement = svgElement?.querySelector('g');
      const bbox = gElement?.getBBox() || { width: 0, height: 0 };
      const width = bbox.width;
      const height = bbox.height;
      const rWidth = rectElement?.width.animVal.value || 0;
      const rHeight = rectElement?.height.animVal.value || 0;

      if (
        gElement &&
        rWidth &&
        rHeight &&
        (width > rWidth || height > rHeight)
      ) {
        let scaleHeight = rHeight / height;
        let scaleWidth = rWidth / width;
        let scale = Math.min(scaleWidth, scaleHeight) - 0.05;

        gElement.style.scale = `${scale}`;
      }
    }, 500);
  }

  useEffect(() => {
    const resizeObserver = debounce(setRectScale, 500);
    window.addEventListener('resize', resizeObserver);

    return () => {
      window.removeEventListener('resize', resizeObserver);
    };
  }, []);

  useEffect(() => {
    setRectScale();
  }, [data]);
}
